import store2 from 'store2';
import { nanoid } from 'nanoid';

export function initBootId() {
    const id = nanoid(32).toUpperCase();
    store2('_boot_id', id);
    return id;
}

export function getBootId() {
    const bootId = store2('_boot_id');
    if (bootId) {
        return bootId
    }
    return initBootId()
}
